import { Navigate, Route, Routes } from "react-router";
import { AuthProvider, useAuth } from "./auth";
import { Layout } from "./components/Layout";
import { AdminPage } from "./pages/AdminPage";
import { DirectoryPage } from "./pages/DirectoryPage";
import { ExportPage } from "./pages/ExportPage";
import { ProfilePage } from "./pages/ProfilePage";
import { LoginPage } from "./pages/LoginPage";
import { LotPage } from "./pages/LotPage";
import { LotsPage } from "./pages/LotsPage";
import { NewLotPage } from "./pages/NewLotPage";
import { NotificationsPage } from "./pages/NotificationsPage";

function Protected({ children, adminOnly = false }: { children: React.ReactNode; adminOnly?: boolean }) {
  const { user, loading } = useAuth();
  if (loading) return <p className="muted" style={{ padding: 24 }}>Загрузка…</p>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return <>{children}</>;
}

export function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          element={
            <Protected>
              <Layout />
            </Protected>
          }
        >
          <Route index element={<LotsPage />} />
          <Route path="lots/new" element={<NewLotPage />} />
          <Route path="lots/:id" element={<LotPage />} />
          <Route path="directory/*" element={<DirectoryPage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="notifications" element={<NotificationsPage />} />
          <Route
            path="export"
            element={
              <Protected adminOnly>
                <ExportPage />
              </Protected>
            }
          />
          <Route
            path="admin/*"
            element={
              <Protected adminOnly>
                <AdminPage />
              </Protected>
            }
          />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
